import Moment from 'moment'

function formatTime(time) {
    let formattedTime = {
        'HH' : ('0' + Moment(time, 'HH:mm:ss').hour()).slice(-2),
        'mm' : ('0' + Moment(time, 'HH:mm:ss').minute()).slice(-2),
        'ss' : '00'
    }

    return formattedTime;
}

function getCurrentTime() {
    var now = Moment();
    return  {
        'HH' : ('0' + Moment(now, 'HH:mm:ss').hour()).slice(-2),
        'mm' : ('0' + Moment(now, 'HH:mm:ss').minute()).slice(-2),
        'ss' : '00'
    }
}

function timeToString(time) {
    let timeString = time.HH + ':' + time.mm + ':00'
    return timeString;
}



export default {
    formatTime,
    timeToString,
    getCurrentTime
}